// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2fyVL","author":"Table_author__th1Uo","authorImage":"Table_authorImage__2HlCR","unreadRow":"Table_unreadRow__1_pfT"};